import { z } from 'zod';

import { TextItem } from './common';

export const RiskCurve = TextItem;
export const RiskFactors = z.array(RiskCurve).default([]);

export type RiskFactors = z.infer<typeof RiskFactors>;
export type RiskCurve = z.infer<typeof RiskCurve>;
